import { Card } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import Reports from "../../components/Reports/Reports";

import heartImage from "@shltelemedicine/shl-ui-lib/dist/assets/brand/heart.svg";

import styles from "./ReportsPage.module.css";

const cardContentImgStyle = {
  backgroundImage: `url(${heartImage})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "contain",
};

const ReportsPage = () => {
  return (
    <div className={`${styles.wrapper} h-100 w-100`}>
      <header className={`${styles.header} p-3`}>
        <p className="mb-0 prim-color">
          <strong>
            <FormattedMessage id="NAV.REPORTS" defaultMessage="Reports" />
          </strong>
        </p>
      </header>
      <Card className="p-3 muted-color app-shadow">
        <div
          className="d-flex p-2 justify-content-center justify-content-lg-start"
          style={cardContentImgStyle}
        >
          <Reports />
        </div>
      </Card>
    </div>
  );
};
export default ReportsPage;
